/**
 * Unidad previsional.
 */
export var UYW = {
  code: 'UYW',
  base: 10,
  exponent: 4
};